import { render, staticRenderFns } from "./awi_config_y.vue?vue&type=template&id=58a9268b&"
import script from "./awi_config_y.vue?vue&type=script&lang=js&"
export * from "./awi_config_y.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports